import * as constants from "redux/constants";

export const updateRoute = (payload) => ({
  type: constants.ROUTE_UPDATE,
  payload,
});
